// src/docs/DocsRoutes.js
import React from "react";
import { Routes, Route } from "react-router-dom";
import DocsLayout from "./DocsLayout";
import { Helmet } from 'react-helmet';
import { useEffect } from 'react';


// Import each doc page
import DocsOverview from "./DocsOverview";
import DocsTokenization from "./DocsConnectWallet";
import DocsConnectWallet from "./DocsConnectWallet";
import DocsWalletDisconnected from "./DocsWalletDisconnected";
import DocsNavigation from "./DocsNavigation";
import DocsSwapLnch from "./DocsSwapLnch";
import DocsDashboard from "./DocsDashboard";
import DocsVerifiedProjects from "./DocsVerifiedProjects";
import DocsBuyTokenizedProject from "./DocsBuyTokenizedProject";
import DocsStakingLNCH from "./DocsStakingLnch";
import DocsHoldings from "./DocsHoldings";
import DocsClaimRefunds from "./DocsClaimRefund";
import DocsProjectStatus from "./DocsProjectStatus";
import DocsLeavingCrowdLaunch from "./DocsLeavingCrowdlaunch";
import DocsMyProfile from "./DocsMyProfile";
import DocsKycUpdates from "./DocsKycUpdates";
import DocsDocumentEdits from "./DocsDocumentsEdit";
import DocsProjectManagement from "./DocsProjectManagement";
import DocsVerifyProject from "./DocsVerifyProject";
import DocsTermsAgreements from "./DocsTermsAgreement";
import DocsPromoteProject from "./DocsPromoteProject";
import Whitepaper from "./Whitepaper";
const DocsRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<DocsLayout />}>
        <Route path="/" element={<DocsOverview />} />
        <Route path="/connect-wallet" element={<DocsConnectWallet />} />
        <Route path="/wallet-disconnected" element={<DocsWalletDisconnected />} />
        <Route path="/navigation" element={<DocsNavigation />} />
        <Route path="/swap-lnch" element={<DocsSwapLnch />} />
        <Route path="/dashboard" element={<DocsDashboard />} />
        <Route path="/verified-projects" element={<DocsVerifiedProjects />} />
        <Route path="/buy-tokenized-project" element={<DocsBuyTokenizedProject />} />
        <Route path="/staking-lnch" element={<DocsStakingLNCH />} />
        <Route path="/holdings" element={<DocsHoldings />} />
        <Route path="/claim-refunds" element={<DocsClaimRefunds />} />
        <Route path="/project-status" element={<DocsProjectStatus />} />
        <Route path="/leaving-crowdlaunch" element={<DocsLeavingCrowdLaunch />} />
        <Route path="/my-profile" element={<DocsMyProfile />} />
        <Route path="/kyc-updates" element={<DocsKycUpdates/>} />
        <Route path="/document-edits" element={<DocsDocumentEdits/>} />
        <Route path="/project-management" element={<DocsProjectManagement/>} />
        <Route path="/verify-project" element={<DocsVerifyProject/>} />
        <Route path="/terms-agreements" element={<DocsTermsAgreements/>} />
        <Route path="/promote-project" element={<DocsPromoteProject/>} />
        <Route path="/whitepaper" element={<Whitepaper/>} />

      </Route>
    </Routes>
  );
};

export default DocsRoutes;
